/**
 * Partner logos on the SDK CDN:
 *   {sdkBaseUrl}/partners/{partnerId}.svg  (preferred — you provide)
 *   {sdkBaseUrl}/partners/{partnerId}.png  (optional fallback)
 *
 * Missing partnerId or missing file → no logo rendered.
 */

const LOGO_EXTENSIONS = ['svg', 'png'];

export function resolveSdkBaseUrl() {
  if (typeof document !== 'undefined') {
    const scripts = document.querySelectorAll('script[src]');
    for (const script of scripts) {
      const src = script.getAttribute('src') || '';
      if (!src.includes('agent-widget') && !src.includes('ttp-agent-sdk')) continue;
      try {
        const url = new URL(src, window.location.href);
        return url.origin + url.pathname.replace(/\/[^/]*$/, '');
      } catch (e) { /* continue */ }
    }
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname || '';
    if (host.includes('cdn.talktopc.com') || host.includes('talktopc.com')) {
      return `${window.location.origin}/ttp-agent-sdk`;
    }
  }

  return 'https://cdn.talktopc.com/ttp-agent-sdk';
}

/** partnerId from wire message, else widget flavor.partnerId. */
export function resolvePartnerId(widget, message) {
  const fromMsg = message?.partnerId
    ?? message?.partner_id
    ?? message?.recipe?.partnerId
    ?? message?.recipe?.partner_id;
  if (fromMsg && String(fromMsg).trim()) {
    return String(fromMsg).trim();
  }

  const flavor = widget?.config?.flavor ?? widget?._flavorObj;
  const fromFlavor = flavor?.partnerId;
  if (fromFlavor && String(fromFlavor).trim()) {
    return String(fromFlavor).trim();
  }

  return null;
}

function probeImage(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

/** @returns {Promise<string|null>} First logo URL that loads, or null. */
export async function resolvePartnerLogoUrl(partnerId, sdkBaseUrl) {
  const id = partnerId?.trim();
  if (!id) return null;

  const base = (sdkBaseUrl || resolveSdkBaseUrl()).replace(/\/$/, '');
  const safeId = encodeURIComponent(id);

  for (const ext of LOGO_EXTENSIONS) {
    const url = `${base}/partners/${safeId}.${ext}`;
    // eslint-disable-next-line no-await-in-loop
    if (await probeImage(url)) {
      return url;
    }
  }

  return null;
}
